import {
    Checkbox,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
} from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { TableColumn } from ".";
import { useEnhancedTableStyles } from "./enhancedTableStyles";

interface EnhancedTableHeadProps {
    columns: TableColumn[];
    rowCount?: number;
    numSelected?: number;
    onRequestSort?: (
        event: React.MouseEvent<HTMLElement, MouseEvent>,
        property: string
    ) => void;
    onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order?: SortDir;
    orderBy?: string;
    hideCheckbox?: boolean;
    checkboxColor?: "default" | "primary" | "secondary";
    isExpansion?: boolean;
    boldColumnHeaders?: boolean;
    checkboxDisabled?: boolean;
}

export const EnhancedTableHead = (props: EnhancedTableHeadProps) => {
    const classes = useEnhancedTableStyles(props);
    const {
        checkboxColor,
        columns,
        numSelected,
        onRequestSort,
        onSelectAllClick,
        order,
        orderBy,
        rowCount,
        hideCheckbox,
        isExpansion,
        boldColumnHeaders,
        checkboxDisabled,
    } = props;
    const createSortHandler = (property: string) => (
        event: React.MouseEvent<HTMLElement, MouseEvent>
    ) => {
        if (onRequestSort) onRequestSort(event, property);
    };
    let firstRenderedColumn = true;

    return (
        <TableHead>
            <TableRow>
                {!hideCheckbox ? (
                    <TableCell padding="none">
                        <Checkbox
                            data-cy="headCheckBox"
                            color={checkboxColor}
                            indeterminate={
                                numSelected > 0 && numSelected < rowCount
                            }
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                            disabled={checkboxDisabled}
                        />
                    </TableCell>
                ) : null}
                {columns.map((col, idx) => {
                    if (col.hidden) return null;
                    const tableCellClasses = classnames(
                        classes.tableCell,
                        {
                            [classes.smallestColumn]:
                                col.columnSize === "smallest",
                            [classes.smallerColumn]:
                                col.columnSize === "smaller",
                            [classes.smallColumn]: col.columnSize === "small",
                            [classes.mediumColumn]: col.columnSize === "medium",
                            [classes.largeColumn]: col.columnSize === "large",
                            [classes.largerColumn]: col.columnSize === "larger",
                            [classes.largestColumn]:
                                col.columnSize === "largest",
                            [classes.firstColumn]:
                                firstRenderedColumn &&
                                (col.align === "left" || !col.align),
                            [classes.boldText]: !!boldColumnHeaders,
                        },
                        col.className
                    );
                    firstRenderedColumn = false;

                    return (
                        <TableCell
                            key={idx}
                            data-cy={`${col.field}-header`}
                            className={tableCellClasses}
                            align={
                                !!col.align
                                    ? col.align
                                    : col.numeric
                                    ? "right"
                                    : "left"
                            }
                            padding={col.disablePadding ? "none" : "default"}
                            sortDirection={
                                orderBy === col.field ? order : false
                            }
                        >
                            {!!onRequestSort && col.sortable ? (
                                <TableSortLabel
                                    data-cy={`${col.title}TableSortLabel`}
                                    active={orderBy === col.field}
                                    direction={order}
                                    onClick={createSortHandler(col.field)}
                                    title={`sort by ${col.title}`}
                                >
                                    {col.title}
                                </TableSortLabel>
                            ) : (
                                <>{col.title}</>
                            )}
                        </TableCell>
                    );
                }, this)}
                {isExpansion ? <TableCell /> : null}
            </TableRow>
        </TableHead>
    );
};
